import { getPluginConfigsForTenant } from "@/Plugins/_EXPORTS";
import { useGetQueryData } from "@/utils/react-query-hooks/general";
import { useHierarchicalAnnotationBarGraphData } from "./useHierarchicalAnnotationBarGraphData";
import { useLegacyAnnotationBarGraphData } from "./useLegacyAnnotationBarGraphData";

const EMPTY_RESULT = { data: [], status: "idle", error: null, isLoading: false };

export const useAnnotationBarGraphData = (
  shouldFetch,
  activeFilters,
  selectedTPLsArrayOptions,
) => {
  const platformConfigs = useGetQueryData("platformConfigs");
  const enableTagsToSubThemesData = !!platformConfigs?.SELF_MANAGED_BASE_CONFIGS
    ?.annotationExplorerConfigs?.visualization?.tagsToSubThemesData;

  const tenantVizConfig =
    getPluginConfigsForTenant()?.annotationExplorer_dataViz;
  const hasTenantHierarchy = !!tenantVizConfig;

  // Two hierarchical configurations resolve to the same hook with parent/child
  // params. Default to subThemes/tags for SM tenants without an explicit
  // tenant config.
  const useHierarchicalPath = enableTagsToSubThemesData || hasTenantHierarchy;
  const hierarchicalParent = tenantVizConfig?.parent || "subThemes";
  const hierarchicalChild = tenantVizConfig?.child || "tags";

  const hierarchicalResult = useHierarchicalAnnotationBarGraphData({
    enabled: shouldFetch && useHierarchicalPath,
    activeFilters,
    selectedTPLsArrayOptions,
    parent: hierarchicalParent,
    child: hierarchicalChild,
  });

  const legacyResult = useLegacyAnnotationBarGraphData({
    enabled: shouldFetch && !useHierarchicalPath,
    activeFilters,
    selectedTPLsArrayOptions,
  });

  if (!shouldFetch) return EMPTY_RESULT;
  if (useHierarchicalPath) return hierarchicalResult;
  return legacyResult;
};
